import './tertiary/easings';
import './tertiary/shapeOverlays';
import './tertiary/simplebar';
import './tertiary/jquery.fancybox';